<!-- import html template -->
<template src="./template.html"></template>

<!-- start JS -->
<script>

export default {
  // name of the component
  name: 'InputText',
  props: ['label', 'forID', 'disabled', 'valueProp', 'selector', 'required', 'requiredMark'],
  data() {
    return {
      focused: false,
      val: '',
    };
  },
  watch: {
    computedValue (){
      this.val = this.valueProp;
    },
  },
  computed: {
    computedValue: {
      cache: false,
      get: function () {
        return this.valueProp;
      },
      set: function (newValue) {
        return newValue;
      }
    },
    errorMsg: {
      // getter
      get: function () {
        return this.required;
      },
      // setter
      set: function (newVal) {
        return this.required = newVal;
      }
    },
  },
  beforeMount() {
    this.val = this.computedValue;
  },
  mounted() {
    this.setFocus(this.focused);
  },
  methods: {
    emitChangeToParent: function (e) {
      this.$emit('inputChange', e, this);
    },
    emitBlurToParent: function (e) {
      this.$emit('inputBlur', e, this);
    },
    setFocus(foc) {
      if (foc || this.val) {
        this.focused = true;
      } else {
        this.focused = false;
      }
    },
  },
  updated: function () {
    this.$nextTick(function () {
      this.setFocus(this.focused);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cmp/inputText/index.vue